/* eslint-disable import/no-named-default */
/* eslint-disable no-await-in-loop */
import { default as UserPilotUtil } from 'userpilot';

const callbackIsIdentifyFunction = callback =>
  callback === UserPilotUtil.Userpilot.identify;

const DEFAULT_DELAY_MS = 500;
const IDENTIFY_DELAY_MS = 3000;

class UserpilotProcessQueue {
  constructor(delayMs = DEFAULT_DELAY_MS) {
    this.delayMs = delayMs;
    this.queue = [];
  }

  sleep(duration = this.delayMs) {
    return new Promise(resolve => setTimeout(resolve, duration));
  }

  add(callback, ...params) {
    this.queue.push([callback, ...params]);

    if (!this.isProcessing) {
      this.process();
    }
  }

  async process() {
    this.isProcessing = true;

    while (this.isProcessing) {
      const [callback, ...params] = this.queue.shift();

      try {
        await callback(...params);
      } catch (error) {
        console.error(error);
      } finally {
        await this.sleep(
          callbackIsIdentifyFunction(callback)
            ? IDENTIFY_DELAY_MS
            : DEFAULT_DELAY_MS,
        );

        this.isProcessing = this.queue.length > 0;
      }
    }
  }

  clear() {
    this.queue = [];
    this.isProcessing = false;
  }
}

const userpilotProcessQueue = new UserpilotProcessQueue();

export { userpilotProcessQueue, UserpilotProcessQueue };
